import React, { useEffect, useRef, useState } from 'react';

import './index.scss';
import { Header, Icon, Popup, Ref } from 'semantic-ui-react';
import { PhoneUtil } from 'utils';
import { ClippedContent } from '../ClippedContent';
import OfficeViewDestinationActiveCall from '../OfficeViewDestinationActiveCall';
import { useDroppable } from '@dnd-kit/core';

const OfficeViewCompanyDestination = ({ destination, togglePinned, pinButtonDisabled, transfer, userPhoneCreds }) => {
    const [isCallsOpen, setIsCallsOpen] = useState(false);
    const [sectionWidth, setSectionWidth] = useState(0);
    const sectionRef = useRef(null);

    const handleOpen = () => {
        if (destination.activeCalls?.length > 0) {
            setIsCallsOpen(true)
        }
    }

    const handleClose = () => {
        setIsCallsOpen(false)
    }

    const source = `company-destination_${destination.destination_id}`;
    const { isOver, setNodeRef, active: call } = useDroppable({
        id: source,
        data: {
            source,
            type: 'company-destination',
            target: destination.fs_destination
        }
    });

    useEffect(() => {
        if (sectionRef?.current) {
            const sectionWidthAux = sectionRef.current.getBoundingClientRect().width;
            setSectionWidth(sectionWidthAux);
        }
    }, [])

    const containerClassName = 'CompanyDestination__container';

    const containerModifiers = [
        destination.activeCalls?.length || !pinButtonDisabled ? "pointer" : "noPointer",
        isOver && !call?.data?.current?.isInternal && "dragging-over"
    ].filter(modifier => modifier).map(modifier => `${containerClassName}--${modifier}`).join(' ');

    return (
        <Popup
            on={'click'}
            onOpen={handleOpen}
            onClose={handleClose}
            open={destination.activeCalls?.length > 0 && isCallsOpen}
            className='CompanyDestination__popup'
            offset={[0, -55]}
            position='bottom left'
            basic
            trigger={(
                <Ref innerRef={setNodeRef}>
                    <div ref={sectionRef} className={`${containerClassName} ${containerModifiers}`}>
                        <div className='CompanyDestination__content'>
                            <div onClick={(event) => {
                                if (!pinButtonDisabled) {
                                    togglePinned(destination.destination_id, !destination.pinned);
                                }
                                event.stopPropagation();
                            }}>
                                <Icon
                                    className={`fa-solid fa-thumbtack CompanyDestination__pin ${destination.pinned && "CompanyDestination__pin--pinned"}`} 
                                    size='large'
                                    disabled={pinButtonDisabled}
                                />
                            </div>
                            <Icon className={PhoneUtil.DESTINATION_TYPES_ICONS[destination.type]} size='large' style={{ marginRight: 15 }} />
                            <div className='CompanyDestination__header'>
                                <ClippedContent>
                                    <Header 
                                        as={'h3'} 
                                        style={{ 
                                            margin: 0, 
                                            display: 'inline'
                                        }}
                                    >
                                        {destination.label}
                                    </Header>
                                </ClippedContent>
                            </div>
                        </div>
                        {destination.activeCalls?.length > 0 && (
                            <div className='CompanyDestination__number'>
                                { destination.activeCalls.length }
                            </div>
                        )}
                    </div>
                </Ref>
            )}
            content={(
                <div style={{ width: sectionWidth }}>
                    <div className='CompanyDestination__openContainer'>
                        <div className='CompanyDestination__content'>
                            <div onClick={(event) => {
                                togglePinned(destination.destination_id, !destination.pinned);
                                event.stopPropagation()
                            }}>
                                <Icon
                                    className={`fa-solid fa-thumbtack CompanyDestination__pin ${destination.pinned && "CompanyDestination__pin--pinned"}`} 
                                    size='large'
                                />
                            </div>
                            <Icon className={PhoneUtil.DESTINATION_TYPES_ICONS[destination.type]} size='large' style={{ marginRight: 15 }} />
                            <div className='CompanyDestination__header'>
                                <ClippedContent>
                                    <Header 
                                        as={'h3'} 
                                        style={{ 
                                            margin: 0, 
                                            display: 'inline'
                                        }}
                                    >
                                        {destination.label}
                                    </Header>
                                </ClippedContent>
                            </div>
                        </div>
                        {destination.activeCalls?.length > 0 && (
                            <div className='CompanyDestination__number'>
                                { destination.activeCalls.length }
                            </div>
                        )}
                    </div>
                    <div className='CompanyDestination__callsOuterContainer'>
                        <div className={'CompanyDestination__callsContainer ' + destination.type}>
                            {destination.activeCalls?.map((call) => <OfficeViewDestinationActiveCall
                                call={call}
                                transfer={transfer}
                                type={destination.type}
                                source={source}
                                key={call.uuid}
                                userPhoneCreds={userPhoneCreds}
                            />)}
                        </div>
                    </div>
                </div>
            )}
        />
    )
}

export default OfficeViewCompanyDestination;

